import { render, staticRenderFns } from "./PersonalFormComponent.vue?vue&type=template&id=574456de&scoped=true"
import script from "./PersonalFormComponent.vue?vue&type=script&lang=js"
export * from "./PersonalFormComponent.vue?vue&type=script&lang=js"
import style0 from "./PersonalFormComponent.vue?vue&type=style&index=0&id=574456de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574456de",
  null
  
)

export default component.exports